import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { filingFormTypeAPI } from '../../utilities/api';
import { FilingFormType } from '../../utilities/interfaces/FilingFormType';

// represents the shape of the slice in state
interface FilingFormTypeState {
  value: any;
}

const initialState: FilingFormTypeState = {
  value: [],
};

const filingSlice = createSlice({
  name: 'stateFilingType',
  initialState,
  reducers: {
    // add new filing item
    addFilingTypeItem(state, action: PayloadAction<FilingFormType>) {
      // its okay to do this because immer makes it immutable
      state.value.push(action.payload);
    },
  },
  extraReducers(builder) {
    builder.addCase(getAllFilingTypes.fulfilled, (state, action) => {
      state.value = action.payload;
    });
  },
});

// Async thunk to fetch data from api
// under extra reducers on fulfilled the redux store is updated
export const getAllFilingTypes = createAsyncThunk('stateFilingType/getFilingTypes', async () => {
  const response = await filingFormTypeAPI.getFilingFormTypes();
  return response;
});

export const { addFilingTypeItem } = filingSlice.actions;
export default filingSlice.reducer;
